import React, { Component } from "react";
import styles from "./cmsUnitSettings.module.scss";
import { TextField, Switch, Select, MenuItem } from "@mui/material";
import TooltipWrapper from "../../../../shared/items/contols/tooltipWrapper";
import "./input.css";
import { withAuth } from "../../../../shared/containers/containerAuth";

let timeOutId = null;

class CmsUnitSettingItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      setting: props.setting,
      isUpdating: false,
      updateIsOk: false,
      error: null,
    };
  }

  setSetting(setting) {
    const { onHancleChange } = this.props;
    onHancleChange(setting);
  }

  setValue(e) {
    const { setting } = this.state;
    setting.value = `${e.target.value}`;

    this.setSetting(setting);
  }

  setOnOff(e) {
    const { setting } = this.state;

    setting.value = `${e.target.checked}`;
    this.setSetting(setting);
  }

  inputField(setting, type, disabled) {
    const value = setting.value;

    return (
      <TextField
        disabled={disabled ? disabled : setting.disableEditing}
        InputProps={{ sx: { height: "30px", width: type === "number" ? "100px" : "200px", backgroundColor: "#ffffff" } }}
        variant="outlined"
        value={value}
        type={type}
        onChange={this.setValue.bind(this)}
      />
    );
  }

  getSwitch(setting, disabled) {
    return (
      <Switch
        disabled={disabled ? disabled : setting.disableEditing}
        checked={setting.value.toLowerCase() === "true"}
        onChange={this.setOnOff.bind(this)}
      />
    );
  }

  timeSpanInput(value, onChange, disabled, tooltip, max = 60) {
    return (
      <TooltipWrapper title={tooltip} position="top">
        <TextField
          size="small"
          disabled={disabled}
          InputProps={{
            sx: { height: "30px", width: `${value}`.length * 25 + 30 + "px", backgroundColor: "#ffffff", padding: "0px" },
            inputProps: { min: 0, max: max },
          }}
          variant="outlined"
          type="number"
          value={value}
          onChange={onChange}
        />
      </TooltipWrapper>
    );
  }

  getTimeSpanField(setting, disabled) {
    disabled = disabled ? disabled : setting.disableEditing;

    const days = Math.trunc(setting.value / 86400);
    const hours = Math.trunc(Math.abs(days * 86400 - setting.value) / 3600);
    const minutes = Math.trunc(Math.abs(days * 86400 + hours * 3600 - setting.value) / 60);
    const seconds = Math.abs(days * 86400 + hours * 3600 + minutes * 60 - setting.value);

    const changeDays = (e) => {
      if (e.target.value === null || e.target.value === "") return;
      if (parseInt(e.target.value) < 0 || parseInt(e.target.value) > 180) return;

      const { setting } = this.state;
      setting.value = `${parseInt(e.target.value) * 86400 + hours * 3600 + minutes * 60 + seconds}`;

      this.setSetting(setting);
    };

    const changeHours = (e) => {
      if (e.target.value === null || e.target.value === "") return;

      const { setting } = this.state;
      setting.value = `${days * 86400 + parseInt(e.target.value) * 3600 + minutes * 60 + seconds}`;

      this.setSetting(setting);
    };

    const changeMinutes = (e) => {
      if (e.target.value === null || e.target.value === "") return;

      const { setting } = this.state;
      setting.value = `${days * 86400 + hours * 3600 + parseInt(e.target.value) * 60 + seconds}`;

      this.setSetting(setting, 0);
    };

    const changeSeconds = (e) => {
      if (e.target.value === null || e.target.value === "") return;

      const { setting } = this.state;
      setting.value = `${days * 86400 + hours * 3600 + minutes * 60 + parseInt(e.target.value)}`;

      this.setSetting(setting);
    };

    return (
      <div style={{ display: "flex", alignItems: "flex-end", fontSize: "20px", fontWeight: "600" }}>
        {this.timeSpanInput(days, changeDays, disabled, "Дни", 180)}.{this.timeSpanInput(hours, changeHours, disabled, "Часы", 23)}:
        {this.timeSpanInput(minutes, changeMinutes, disabled, "Минуты")}:{this.timeSpanInput(seconds, changeSeconds, disabled, "Секунды")}
      </div>
    );
  }

  getDropboxTypeProcess(setting, disabled) {
    const types = [
      {
        id: "0",
        title: "Стандарт",
      },
      {
        id: "1",
        title: "Без обработки (только точки)",
      },
      {
        id: "2",
        title: "Минимальная обработка (Дистанция и т.д.)",
      },
    ];

    return (
      <Select
        style={{ width: "200px", height: "24px", margin: "0px", fontSize: "12px" }}
        onChange={(e) => {
          this.setValue(e);
        }}
        placeholder={"Район"}
        value={setting.value}
        disabled={disabled ? disabled : setting.disableEditing}
      >
        {types.map((x) => {
          return (
            <MenuItem key={x.id} value={x.id} name={x.title} className={styles.MuiButtonBase_resolve}>
              {x.title}
            </MenuItem>
          );
        })}
      </Select>
    );
  }

  getInput(setting, disabled) {
    switch (setting.type) {
      case 0:
        return this.inputField(setting, "number", disabled);
      case 2:
        return this.getSwitch(setting, disabled);
      case 3:
        return this.getTimeSpanField(setting, disabled);
      case 4:
        return this.inputField(setting, "number", disabled);
      case 5:
        return this.inputField(setting, "text", disabled);
      case 6:
        return this.getDropboxTypeProcess(setting, disabled);
      default:
        return setting.value;
    }
  }

  render() {
    const { setting } = this.state;
    const { isGrouping = false, data } = this.props;

    const disabled = !data.permissions.includes(11004);

    return (
      <div style={{ width: "100%" }}>
        <div style={{ color: setting.isMomental ? "black" : "#1976d2" }}>
          <div className={styles.title}>{isGrouping === true ? <h5>{setting.title}</h5> : <h4>{setting.title}</h4>}</div>
        </div>

        <div className={styles.inputContainer}>
          {this.getInput(setting, disabled)} <div> {setting.valueAfter} </div>
        </div>
      </div>
    );
  }
}

export default withAuth(CmsUnitSettingItem);
